import styled from '@emotion/styled';
import { HTMLAttributes, ReactNode, useEffect, useState } from 'react';

const CarouselContainer = styled.div<{ height: string; rising: string }>`
  height: ${({ height }) => height};
  overflow: hidden;
  > div {
    transform: ${({ height, rising }) =>
      rising === 'true' ? `translateY(-${height})` : 'translateY(0)'};
    transition: ${({ rising }) => (rising === 'true' ? 'all .3s' : 'none')};
  }
`;

export interface CarouselProps extends HTMLAttributes<HTMLDivElement> {
  height: string;
  contentList: ReactNode[];
}

function Carousel(props: CarouselProps) {
  const { contentList, ...otherProps } = props;

  const [rising, setRising] = useState(false);

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextIndex = currentIndex >= contentList.length - 1 ? 0 : currentIndex + 1;

  useEffect(() => {
    const timer = setInterval(() => {
      setRising(true);
    }, 5 * 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <CarouselContainer rising={String(rising)} {...otherProps}>
      <div
        onTransitionEnd={() => {
          setRising(false);
          setCurrentIndex(nextIndex);
        }}
      >
        {[...contentList.slice(currentIndex), ...contentList.slice(0, currentIndex)]}
      </div>
    </CarouselContainer>
  );
}

export default Carousel;
